import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imSettlementFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/filters/settlement-filter/settlement-filter.html'),
        controller: 'SettlementFilterController',
        controllerAs: 'SettlementFilterCtrl',
        bindings: {
            client: '<',
            settlement: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/settlement-filter/settlement-filter.component.ts